import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class TenantDetailsFormStateTenant extends FormStateBase {
    name: FormFieldState = new FormFieldState();
    cloudHealthClientApiId: FormFieldState = new FormFieldState();
    odinAccountId: FormFieldState = new FormFieldState();
    cidn: FormFieldState = new FormFieldState();
    odinPayToolId: FormFieldState = new FormFieldState();
    isPartnerSalesChannel: FormFieldState = new FormFieldState();
    partnerDealerCode: FormFieldState = new FormFieldState();
    accountManagerName: FormFieldState = new FormFieldState();
    awsDirectMasterAccountId: FormFieldState = new FormFieldState();
    cloudOrganizationId: FormFieldState = new FormFieldState();
    authenticationDomain: FormFieldState = new FormFieldState();
    dome9AccountId: FormFieldState = new FormFieldState();
    azurePlanOdinSubscriptionId: FormFieldState = new FormFieldState();

    constructor() {
        super();
        this.setForm(this);
    }
}
